document.addEventListener("DOMContentLoaded", function () {
  // Handle variant change (prevent unintended redirect)
  const variantSelects = document.querySelectorAll(".variant-select");
  variantSelects.forEach(function (select) {
    select.addEventListener("change", function (event) {
      event.preventDefault(); // Prevent page change
    });
  });

  // Initialize the ProductForm with AJAX logic
  const forms = document.querySelectorAll(".ajax-product-form");
  forms.forEach(function (form) {
    new theme.AjaxProduct(form, ".add-to-cart");
    form.addEventListener("submit", function (event) {
      event.preventDefault(); // Prevent form redirect
    });
  });
});

// Success handler to open the cart drawer
theme.AjaxProduct.prototype.success = function (product) {
  var errors = this.form.querySelector(".errors");
  if (errors) errors.remove();

  // Dispatch custom event
  document.dispatchEvent(
    new CustomEvent("ajaxProduct:added", {
      detail: { product: product, addToCartBtn: this.addToCart },
    })
  );

  // Open the cart drawer
  const cartDrawer = document.querySelector(".cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("is-active");
  } else {
    console.warn("Cart drawer not found!");
  }
};

// new code
document.addEventListener("DOMContentLoaded", function () {
  const freeShippingBar = document.querySelector("#free-shipping-bar");
  if (!freeShippingBar) return;

  const freeShippingThreshold = parseFloat(freeShippingBar.dataset.threshold);
  const messageReached = freeShippingBar.dataset.messageReached;
  const messageRemainingTemplate = freeShippingBar.dataset.messageRemaining;

  const messageElement = document.querySelector("#free-shipping-message");
  const progressBar = document.querySelector("#progress-bar");

  let previousCartTotal = null;

  const updateFreeShippingBar = async () => {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Failed to fetch cart data");

      const cart = await response.json();
      const cartTotal = cart.total_price / 100; // Convert cents to dollars
      if (cartTotal === previousCartTotal) return; // Avoid redundant updates

      previousCartTotal = cartTotal;
      const remainingAmount = Math.max(freeShippingThreshold - cartTotal, 0);
      const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

      if (remainingAmount > 0) {
        messageElement.textContent = messageRemainingTemplate.replace(
          "{{ amount }}",
          `$${remainingAmount.toFixed(2)}`
        );
      } else {
        messageElement.textContent = messageReached;
      }

      progressBar.style.width = `${progress}%`;
    } catch (error) {
      console.error("Error updating free shipping bar:", error);
    }
  };

  // Poll cart every 3 seconds
  setInterval(updateFreeShippingBar, 1500);

  // Initial update
  updateFreeShippingBar();
});

// base version
// document.addEventListener("DOMContentLoaded", function () {
//   function updateFreeShippingBar(cartTotal) {
//     const freeShippingBar = document.querySelector(".progress-bar");
//     const freeShippingMessage = document.querySelector(
//       ".free-shipping-message"
//     );
//     const freeShippingContainer = document.querySelector(".free-shipping-bar");

//     // Retrieve the threshold and messages dynamically from the data attributes
//     const freeShippingThreshold = parseFloat(
//       freeShippingContainer.getAttribute("data-threshold")
//     );
//     const messageReached = freeShippingContainer.getAttribute(
//       "data-message-reached"
//     );
//     const messageRemainingTemplate = freeShippingContainer.getAttribute(
//       "data-message-remaining"
//     );

//     if (cartTotal >= freeShippingThreshold) {
//       // Display the message when free shipping is reached
//       freeShippingMessage.textContent = messageReached;
//       freeShippingBar.style.width = "100%";
//     } else {
//       // Calculate the remaining amount and progress percentage
//       const amountRemaining = (freeShippingThreshold - cartTotal).toFixed(2);
//       const progressPercentage = (cartTotal / freeShippingThreshold) * 100;

//       // Replace placeholder in the remaining message template with the amount remaining
//       const remainingMessage = messageRemainingTemplate.replace(
//         "{{ amount }}",
//         `$${amountRemaining}`
//       );
//       freeShippingMessage.textContent = remainingMessage;
//       freeShippingBar.style.width = `${progressPercentage}%`;
//     }
//   }

//   function fetchCartAndUpdateBar() {
//     fetch("/cart.js")
//       .then((response) => response.json())
//       .then((cart) => {
//         const cartTotal = cart.total_price / 100; // Convert from cents to dollars
//         updateFreeShippingBar(cartTotal);
//       })
//       .catch((error) => console.error("Error fetching cart data:", error));
//   }

//   // Listen for cart updates to refresh the bar
//   document.addEventListener("ajaxProduct:added", fetchCartAndUpdateBar);
//   document.addEventListener("cart:updated", fetchCartAndUpdateBar);

//   // Initial load
//   fetchCartAndUpdateBar();
// });

function ensureSlickForFeaturedProducts() {
  const featuredSection = document.querySelector(".featured-collection-cart");
  const featuredCarousel = document.querySelector(
    ".featured-collection-carousel"
  );

  if (featuredSection && featuredCarousel) {
    // Ensure the section is hidden initially
    featuredSection.style.visibility = "hidden";

    // Check if Slick is already initialized
    if (!featuredCarousel.classList.contains("slick-initialized")) {
      $(featuredCarousel).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    // Display the section after Slick initialization
    featuredSection.style.visibility = "visible";
  } else {
    console.warn("Featured products section or carousel not found!");
  }
}

// Listen for custom events and trigger Slick setup
document.addEventListener("ajaxProduct:added", ensureSlickForFeaturedProducts);
document.addEventListener("cart:updated", ensureSlickForFeaturedProducts);

// Ensure it runs on page load as well
document.addEventListener("DOMContentLoaded", ensureSlickForFeaturedProducts);
